import { render, staticRenderFns } from "./ChecklistBox.vue?vue&type=template&id=5fd41da8"
import script from "./ChecklistBox.vue?vue&type=script&lang=js"
export * from "./ChecklistBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports